module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--messaging main--full-height"
  }, [_c('div', {
    staticClass: "messaging group group--first-last group--wide messaging--sidebar"
  }, [_c('ui-messaging-sidebar', {
    key: "sidebar"
  }), _vm._v(" "), (_vm.stage === 'inbox' || _vm.stage === 'outbox') ? _c('module-inbox') : (_vm.stage === "view") ? _c('module-view-message') : _vm._e(), _vm._v(" "), (_vm.stage === "compose") ? _c('module-compose-message') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6527452c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/messaging/Messages.vue
// module id = 522
// module chunks = 0